module.exports = {"310110001":"定海路街道","310110006":"平凉路街道","310110008":"江浦路街道","310110009":"四平路街道","310110012":"控江路街道","310110013":"长白新村街道","310110015":"延吉新村街道","310110016":"殷行街道","310110018":"大桥街道","310110019":"五角场街道","310110020":"新江湾城街道","310110101":"五角场镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310110.json
// module id = 816
// module chunks = 0